import * as React from 'react';
import { ShieldAlert, Check } from 'lucide-react';

interface DisclaimerModalProps {
  onAccept: () => void;
}

export default function DisclaimerModal({ onAccept }: DisclaimerModalProps) {
  const stopPropagation = (e: React.MouseEvent | React.PointerEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 z-[500] flex items-center justify-center p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-200"
      onPointerDown={stopPropagation}
    >
      <div
        className="w-full max-w-lg glass-panel rounded-[2.5rem] border border-white/10 bg-slate-900 overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300 flex flex-col shadow-2xl"
        onPointerDown={stopPropagation}
      >
        <div className="px-8 py-6 border-b border-white/5 flex justify-between items-center bg-gradient-to-r from-orange-600/20 to-transparent shrink-0">
          <div className="flex items-center gap-3">
            <div className="bg-orange-500 text-white p-2.5 rounded-xl">
              <ShieldAlert size={20} />
            </div>
            <div>
              <h2 className="text-sm font-black uppercase tracking-widest text-white/90">Technical Disclaimer</h2>
              <p className="text-[9px] text-orange-500 font-bold uppercase tracking-wider">Free In-Development Utility</p>
            </div>
          </div>
        </div>

        <div className="p-8 space-y-6">
          <div className="text-xs text-slate-300 leading-relaxed space-y-4">
            <p>
              Please read this disclaimer carefully before using **TradeSketch** (the "Application").
            </p>
            <p>
              This Application is currently a **free, in-development preview** owned and operated by **CadOps Pty Ltd** (ACN 663 949 970). By using this Application, you acknowledge and agree to the following terms:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-slate-400">
              <li>
                <strong>No Liability:</strong> CadOps Pty Ltd provides this tool "as is" and holds absolute zero liability for the accuracy, legality, or standard compliance of any plans, drawings, or reports generated.
              </li>
              <li>
                <strong>Verification Required:</strong> All site capture sketches, fixture counts, and generated PDF schedules must be verified by a licensed professional to ensure compliance with <strong>AS/NZS 3500</strong> standards.
              </li>
              <li>
                <strong>Beta Status:</strong> The tool is currently in active development. Features may change or cease without notice.
              </li>
            </ul>
          </div>

          <div className="pt-2 flex gap-3 shrink-0">
            <button
              onClick={onAccept}
              className="flex-1 px-6 py-4 bg-orange-600 hover:bg-orange-500 text-white font-black text-xs uppercase tracking-widest rounded-2xl shadow-xl shadow-orange-950/40 flex items-center justify-center gap-2 transition-all active:scale-95"
            >
              <Check size={16} /> I Accept & Agree
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
